import React from 'react';
import { withRouter } from 'react-router';

import qs from 'qs';
import { connect } from 'react-redux';
import { fetchSession } from '../actions/sessions';
import { SESSION_UPDATED } from '../services/Auth';

import Header from '../containers/Header';
import FlashMessageList from '../containers/FlashMessageList';
import Login from '../components/Login';

import '../vendor/semantic/dist/semantic.min.css';
import '../styles/App.css';

class App extends React.Component {
  constructor(props) {
    super(props);

    const params = qs.parse(this.props.location.search.slice(1));

    if (!props.auth.isAuthenticated() && params.token) {
      props.auth.login(params.token);
    }

    props.auth.on(SESSION_UPDATED, () => {
      props.fetchSession();
    });
  }

  componentWillMount() {
    this.props.fetchSession();
  }

  setDocumentTitle(title) {
    document.title = title ? `${title} at teampicture` : `teampicture`;
  }

  render() {
    const { currentTeam } = this.props;
    const { children, ...childrenProps } = this.props;

    if (!this.props.auth.isAuthenticated()) {
      return <Login />;
    }

    this.setDocumentTitle(currentTeam && currentTeam.name);

    return (
      <div className="App">
        <Header {...this.props} />
        <main>
          <FlashMessageList />
          {this.props.children &&
            React.cloneElement(this.props.children, { ...childrenProps })}
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.sessions.user,
  currentTeam: state.teams.team
});

const mapDispatchToProps = dispatch => ({
  fetchSession: () => {
    dispatch(fetchSession());
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/containers/App.js